export default "__VITE_ASSET__BAPXCAOy__"